import { useId } from 'react';

/** Seletor nativo: mantém teclado e apresentação acessível do sistema. */
export function Selecao({
  rotulo,
  valor,
  opcoes,
  aoMudar,
  className,
}: {
  rotulo: string;
  valor: string;
  opcoes: ReadonlyArray<{ valor: string; rotulo: string }>;
  aoMudar: (valor: string) => void;
  className?: string;
}) {
  const id = useId();
  return (
    <label className={className} htmlFor={id}>
      <span className="visualmente-oculto">{rotulo}</span>
      <select
        id={id}
        value={valor}
        onChange={(event) => aoMudar(event.target.value)}
      >
        {opcoes.map((opcao) => (
          <option key={opcao.valor} value={opcao.valor}>
            {opcao.rotulo}
          </option>
        ))}
      </select>
    </label>
  );
}
